import React from 'react';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import Icon from './Icon';

interface IconButtonProps {
  icon: IconProp;
  onClick?: () => void;
  disabled?: boolean;
  active?: boolean;
  size?: SizeProp;
  className?: string;
  title?: string;
  'aria-label'?: string;
  children?: React.ReactNode;
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  disabled = false,
  active = false,
  size = '1x',
  className = '',
  title,
  'aria-label': ariaLabel,
  children,
  ...props
}) => {
  const baseClasses = 'px-2 py-1 rounded-md text-sm font-medium transition-colors inline-flex items-center space-x-1';
  const activeClasses = active
    ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300'
    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-700';
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';

  const classes = `${baseClasses} ${activeClasses} ${disabledClasses} ${className}`;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classes}
      title={title}
      aria-label={ariaLabel}
      {...props}
    >
      <Icon icon={icon} size={size} />
      {children && <span>{children}</span>}
    </button>
  );
};

export default IconButton;